import { createGlobalStyle } from "styled-components";

export const AppTheme = {
  color: {
    primaryDark: "#2473b7",
    primary: "#3d8acd",
    danger: "#ed1c24",
    dangerDark: "#c61920",
    text: "#575957",
    bg: "#f5f5f5"
  }
};

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
  
	body {
		font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		color: ${AppTheme.color.text};
	}
`;
